module.exports = __webpack_public_path__ + "static/media/hero.46d0472c.svg";